import axios from 'axios'
import { Loading, Message, Notification } from 'element-ui'
import store from '../store/index'
import Router from '../router/index.js'

import { API_PREFIX } from '../config'

//根据环境 改变接口地址 
var resultApi={
    	baseUrl:API_PREFIX.produceApi,
    	imgPrev:API_PREFIX.imgPrev 
    } 

var instance = axios.create({
	baseURL: resultApi.baseUrl,
	timeout: 200000,
	headers: {
		'weiweiHeader': 'foobar66'
	}
});
export function ajaxPost(url, data) {
	let args={
        "functionSysId":1,//utils.getSysId(),
        "functionAdminId":1,//utils.getAdminId(),
        ...data
    }
	//promise
	let p = new Promise(function(resolve, reject) {
		instance({
			method: 'post',
			url: url,
			data:args
		}).then(function(response) {
			if(!response.data.errorCode){
				Message({
					message: "返回数据格式异常",//接口返回一个页面
					type: 'error',
					duration: 1500
				});
			}else if(response.data.errorCode == -20000){
				Message({
					message: "token失效",
					type: 'error',
					duration: 1500
				});
			}else{
				if(response.data.errorCode == 200){
					
				}else{
					Message({
						message:response.data.errorMsg,
						type: 'error',
						duration: 1500
					});
				}
				
			}
			resolve(response.data)//resolve
		}).catch(function(response) {
			Message({
				message: "捕获异常",
				type: 'error',
				duration: 1500
			});
			reject(response.data)//reject
		})
	})
	return p
	
}
